import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolBarComponent } from './tool-bar.component';
import { LunaCommonModule } from '../../../../common/common.module';
import { DataTableOptionsComponent } from './data-table-options/data-table-options.component';
import { RICSMenuModule } from '../../menu/menu.module';
import { PrintOptionsComponent } from './print-options/print-options.component';

@NgModule({
    imports: [
        CommonModule,
        LunaCommonModule,
        RICSMenuModule
    ],
    declarations: [
        ToolBarComponent,
        DataTableOptionsComponent,
        PrintOptionsComponent
    ]
})
export class ToolBarModule { }
